
<div class="height-64 bg-gray typo_10_B d-flex flex-row align-items-center justify-content-center">
    <div class="me-4">Tous droits réservés «Mon École, Ma baleine » 2021-2031</div>
    <!--<div>Mentions légales</div>-->
</div>